import loadable from 'helper/loadable'

const Home = loadable(() => import('view/page/home'))
const Login = loadable(() => import('view/page/login'))
const UserManagement = loadable(() => import('view/page/user-management'))
const ArticleManagement = loadable(() => import('view/page/article-management'))
const WebpageManagement = loadable(() => import('view/page/webpage-management'))
const CategoryManagement = loadable(() => import('view/page/category-management'))
const SiteManagement = loadable(() => import('view/page/site-management'))
const DatasetManagement = loadable(() => import('view/page/dataset-management'))
const DiscoveryManagement = loadable(() => import('view/page/discovery-management'))
const TagManagement = loadable(() => import('view/page/tag-management'))
const HelpManagement = loadable(() => import('view/page/help-management'))
const InsightManagement = loadable(() => import('view/page/insight-management'))
const LatestPosts = loadable(() => import('view/page/latest-posts'))
const PreviewArticles = loadable(() => import('view/page/preview-articles'))
const Article = loadable(() => import('view/page/article'))
const Help = loadable(() => import('view/page/help'))
const Discovery = loadable(() => import('view/page/discovery'))
const Site = loadable(() => import('view/page/site'))
const SearchResults = loadable(() => import('view/page/search-results'))
const Webpage = loadable(() => import('view/page/webpage'))
const Unauthorised = loadable(() => import('view/component/unauthorised-page'))
const UserMetrics = loadable(() => import('view/page/user-metrics'))

export {
  Article,
  ArticleManagement,
  CategoryManagement,
  DatasetManagement,
  Discovery,
  DiscoveryManagement,
  Help,
  HelpManagement,
  Home,
  InsightManagement,
  LatestPosts,
  Login,
  PreviewArticles,
  SearchResults,
  Site,
  SiteManagement,
  TagManagement,
  UserManagement,
  UserMetrics,
  Unauthorised,
  WebpageManagement,
  Webpage
}
